import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getAlertPrefs,
  getSelectedTab
} from "@tvg/sh-lib-preferences/redux/selectors";
import tvgConf from "@tvg/conf";
import { getAccountNumber, getResidenceState } from "@urp/store-selectors";
import { useLocation } from "react-router-dom";
import ConfirmModal from "./components/ConfirmModal";
import EmailUnsubscribe from "./components/Unsubscribe";
import onPageViewGTMEvent from "./utils/gtm/pageView";
import PreferencesCenter from "./components/PreferencesCenter";
import useTabs from "./hooks/useTabs";
import useTabSelection from "./hooks/useTabSelection";

interface Props {
  showUnsubscribe: boolean;
}

export const Preferences = ({ showUnsubscribe }: Props) => {
  const { state } = useLocation();
  const selectedTab = useSelector(getSelectedTab);
  const accountId = useSelector(getAccountNumber);
  const residenceState = useSelector(getResidenceState);
  const alertState = useSelector(getAlertPrefs);
  const { tabs, defaultTab, hasNotificationTab } = useTabs(state?.selectedTab);
  const onSelectTab = useTabSelection();

  useEffect(() => {
    if (
      tvgConf().product === "tvg4" &&
      !!accountId &&
      !!residenceState &&
      !showUnsubscribe
    ) {
      onPageViewGTMEvent({
        accountId,
        selectedTab: defaultTab.toLowerCase(),
        residenceState
      });
    }
  }, [accountId, residenceState]);

  if (showUnsubscribe) {
    return <EmailUnsubscribe />;
  }

  return (
    <>
      <PreferencesCenter
        onSelect={(tab) => onSelectTab(tab, selectedTab)}
        selectedTab={selectedTab || defaultTab}
        tabs={tabs}
        hasAlert={alertState.show}
        hasNotificationTab={hasNotificationTab}
      />
      <ConfirmModal />
    </>
  );
};

export default Preferences;
